module.exports = __webpack_public_path__ + "static/media/Tick-Box-Unselected-Disabled.203a701b.svg";